import React from 'react';

import { ReactComponent as SortIdentifierIco } from '../../static/imgs/sortIdentifier.svg';
import { IProps } from './types';

const SortIdentifier: React.FC<IProps> = ({color = '#797A8D'}) => <SortIdentifierIco style={{color}}/>;

export default SortIdentifier;
